import {
  Component,
  Injector,
  OnInit,
  Optional,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { CommonModule } from "@angular/common";
import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler } from "@wm/components-base";
import { generateGUId, runtimeEventManager, setCSS } from '@wm/core';

const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-alertdialog',
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

const alertMap: Record<string, string> = {
  information: 'info',
  error: 'danger',
  success: 'success',
  warning: 'warning'
};
@Component({
  selector: '[wmAlertDialog]',
  template: ` <div init-widget class="app-view dialog-view clearfix">
    <div class="app-dialog modal-dialog app-alert-dialog" [ngStyle]="{width: width}" *ngIf="loadDialogContent">
        <div class="modal-content">
        <div class="app-dialog-header modal-header">
          <button aria-label="Close" class="app-dialog-close close" [ngClass]="{'btn-text': isPrism}" title="Close">
              <span class="app-icon wi wi-clear" aria-hidden="true"></span>
          </button>
            <!-- Change the header tag based on the heading level -->
          <ng-container [ngSwitch]="headinglevel">
            <ng-container *ngSwitchCase="'h1'">
              <h1 class="app-dialog-title modal-title">
                <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
              </h1>
            </ng-container>
            <ng-container *ngSwitchCase="'h2'">
              <h2 class="app-dialog-title modal-title">
                <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
              </h2>
            </ng-container>
            <ng-container *ngSwitchCase="'h3'">
              <h3 class="app-dialog-title modal-title">
                <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
              </h3>
            </ng-container>
            <ng-container *ngSwitchCase="'h4'">
              <h4 class="app-dialog-title modal-title">
                <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
              </h4>
            </ng-container>
            <ng-container *ngSwitchCase="'h5'">
              <h5 class="app-dialog-title modal-title">
                <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
              </h5>
            </ng-container>
            <ng-container *ngSwitchCase="'h6'">
              <h6 class="app-dialog-title modal-title">
                <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
              </h6>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <h4 class="app-dialog-title modal-title">
                <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
              </h4>
            </ng-container>
          </ng-container>
          <ng-template #headerTemplate>
            <i [ngClass]="iconclass" [ngStyle]="{width: iconwidth, height: iconheight, margin: iconmargin}"  *ngIf="iconclass && !iconurl"></i>
            <img data-identifier="img" [src]="iconurl" *ngIf="iconurl" [ngStyle]="{width:iconwidth, height:iconheight, margin:iconmargin}"/>
            <span class="dialog-heading" [textContent]="title" [id]="titleId"></span>
          </ng-template>

        </div>

        <div class="app-dialog-body modal-body" apply-styles="scrollable-container">
            <p class="app-dialog-message  text-{{alerttypeClass}}" [ngClass]="{'app-label': isPrism}"> {{message}}</p>
        </div>
        <div class="app-dialog-footer modal-footer">
        <button class="btn-primary ok-action btn app-button" aria-label="Submit button">{{oktext}}</button>
        </div>
      </div>
    </div>
</div>`,
  providers: [
    provideAsWidgetRef(AlertDialogComponent),
  ],
  exportAs: 'wmAlertDialog',
  standalone: true,
  imports: [CommonModule],
  styles: []
})
export class AlertDialogComponent extends StylableComponent implements OnInit {
  static initializeProps = register('wm-alertdialog');
  @ViewChild('dialogTemplate', {static: true}) dialogTemplate: TemplateRef<any>;

  public titleId: string = 'wmdialog-' + generateGUId();
  override width:string;
  message?: string;
  oktext?: string;
  title?: string;
  iconclass: string;
  alerttype?: string;
  iconurl: string;
  iconmargin: string;
  iconheight: string;
  iconwidth: string;
  loadDialogContent: boolean = false;
  headinglevel: string = 'h4';
  isPrism: boolean;
  alerttypeClass: any;

  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
    const projectService = runtimeEventManager.getService('projectService');
    this.isPrism = projectService.isPrism();
    this.registerPropertyChangeListener((key: string, nv: any, ov?: any) => {
      if (key === "height") {
        setCSS(this.nativeElement as HTMLElement, key, 'auto');
        const el = this.nativeElement.querySelector('.dialog-view .app-dialog') as HTMLElement;
        if (el) {
          setCSS(el, key, 'auto');
        }
      }else if (key === "width") {
        setCSS(this.nativeElement as HTMLElement, key, '100%');
      }
    })
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.message = this.message || this.$attrs.get('message.bind');
    this.title = this.title || this.$attrs.get('title.bind');
    this.oktext = this.oktext || this.$attrs.get('oktext.bind');
    this.alerttype = this.alerttype || this.$attrs.get('alerttype.bind');
    this.alerttypeClass = this.alerttype ? alertMap[this.alerttype] : '';
  }

  override get stylerEl(): HTMLElement | null {
    return this.nativeElement.querySelector('.modal-dialog');
  }

  override onPropertyChange(key: string, nv: any, ov?: any) {
    if (key === 'alerttype' && nv) {
       this.alerttypeClass = alertMap[nv]
    }
  }

  override onStyleChange(key: string, nv: any, ov?: any) {
    if (key === 'height' && nv !== ov) {
      this.$element.find('.modal-body').css('height', nv);
    }
  }
}
